import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import AliveMembershipSelectBox from '../../../../../Component/MemberComponent/AliveMembershipSelectBox';
import AliveScheduleSelectBox from '../../../../../Component/MemberComponent/AliveScheduleSelectBos';
import FetchModule from '../../../../Share/Network/FetchModule';
import CourseHistoryCalenderInput from '../../../../../Component/MemberComponent/CourseHistoryCalenderInput';
import LessonNoteTextArea from '../../../../../Component/MemberComponent/LessonNoteTextArea';
import CourseHistoryTimeInput from '../../../../../Component/MemberComponent/CourseHistoryClassTimeInput';
import DeductionCountInput from '../../../../../Component/MemberComponent/MemberDetail/DeductionCountInput';
import CourseHistoryTeacherSelectBox from '../../../../../Component/MemberComponent/CourseHistoryTeacherSelectBox';
import { useTheme } from '../../../../../Context/ThemeContext';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function CourseHistoryAddModal(props) {
  const { memberId, memberName, rendering, onClickClose } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [membershipValue, setMembershipValue] = useState({
    lessonId: 0,
    membershipName: t('memberDetail.select'),
    lessonAndScheduleInfos: []
  })
  const [scheduleValue, setScheduleValue] = useState({
    scheduleId: 0,
    className: t('memberDetail.select'),
    classTime: '',
  })

  const [teachers, setTeachers] = useState([]);
  const [teacherValue, setTeacherValue] = useState({
    teacherId: 0,
    teacherName: t('memberDetail.select')
  });
  const [membershipOption, setMembershipOption] = useState([]);
  const [scheduleOption, setScheduleOption] = useState([]);
  const [classDate, setClassDate] = useState(moment().format('YYYY.MM.DD'));

  const [isClickedNoneLesson, setIsClickedNoneLesson] = useState(false);
  const [classTime, setClassTime] = useState('');
  const [deduction, setDeduction] = useState('');
  const [lessonNote, setLessonNote] = useState('');


  // MemberShip Data API Call //
  useEffect(() => {
    let requestData = {
      memberId: memberId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        // const responseData = await fetchModule.postDataVersion2('membership/alive/', 'POST', requestData);
        const responseData = await fetchModule.postDataVersion2('membership/alive/history', 'POST', requestData);
        if (responseData.status === 200) {
          setMembershipOption(responseData.data);
        }
        else alert(t('memberDetail.courseAddModal.alertDataLoadFailed'));
      }
    )();
  }, [memberId])

  // MemberShip Data API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('teacher/', 'GET');
        
        if (responseData.status === 200) {
          setTeachers(responseData.data.teachers);
        }
      }
    )();
  }, [])

  // 등록 회원권에 관련해서 데이터 정리 //
  useEffect(() => {
    let scheduleOptions = [];
    let scheduleData = membershipValue.lessonAndScheduleInfos.slice();

    for (let i = 0; i < scheduleData.length; i++) {
      // 수업은 설정되어있지만 스케줄 설정이 안되어있는 경우 //
      if (scheduleData[i].classDate === undefined) continue;

      // 개설기간안에 들어있을 경우
      if (moment(scheduleData[i].classDate).format('YYYY.MM.DD') <= moment(classDate, 'YYYY.MM.DD').format('YYYY.MM.DD')
        && moment(scheduleData[i].endDate).format('YYYY.MM.DD') >= moment(classDate, 'YYYY.MM.DD').format('YYYY.MM.DD')
        && (scheduleData[i].applyWeek.includes(moment(classDate, 'YYYY.MM.DD').format('ddd')) || scheduleData[i].applyWeek === 'All')) {
        scheduleOptions.push(scheduleData[i]);
      }
    }

    setScheduleValue({
      scheduleId: 0,
      className: t('memberDetail.select'),
      classTime: '',
    });

    setScheduleOption(scheduleOptions);
  }, [membershipValue, classDate])

  function decideMemberName() {
    if (memberName === undefined || memberName === '') return t('memberDetail.courseAddModal.courseAddTitle');
    else return t('memberDetail.courseAddModal.courseAddTitleWithName').replace('{memberName}', memberName);
  }

  function CalenderClick(className) {

  }
  
  // ClassTime 포맷 확인 //
  function isValidTimeRangeFormat(value) {
    const timeRangeRegex = /^([01]\d|2[0-3]):([0-5]\d)-([01]\d|2[0-3]):([0-5]\d)$/;
    return timeRangeRegex.test(value);
  }

  // 추가하기 클릭시 //
  function onClickSave() {
    // if (membershipValue.membershipName === '선택') {
    //   alert('회원님의 회원권을 선택해주세요!');
    //   return;
    // }
    // else if (scheduleValue.scheduleId === 0) {
    //   alert('추가할 수업을 선택해주세요!');
    //   return;
    // }

    // let requestData = {
    //   classDate: moment(classDate).format('YYYY-MM-DDT00:00:00'),
    //   classTime: scheduleValue.classTime,
    //   lessonId: scheduleValue.lessonId,
    //   status: 1,
    //   userId: membershipValue.userId,
    //   scheduleId: scheduleValue.scheduleId,
    //   usageId: membershipValue.usageId
    // }

    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.postData('reserve/create/course', 'POST', requestData);

    //     if (responseData.status === 200) {
    //       rendering();
    //       onClickClose();
    //     }
    //     else if (responseData.status === 201) {
    //       alert('이미 수강한 시간입니다!');
    //       return;
    //     }
    //     else if (responseData.status === 202) {
    //       alert('예약 가능 횟수를 초과하였습니다!');
    //       return;
    //     }
    //     else alert("서버연결에 실패하였습니다. 잠시후 다시시도해 주세요.");
    //   }
    // )();


    if (membershipValue.lessonId === 0) {
      alert(t('memberDetail.courseAddModal.alertSelectMemberMembership'));
      return;
    }
    else if (isClickedNoneLesson) {
      if (teacherValue.teacherId === 0) {
        alert(t('memberDetail.courseAddModal.alertSelectCoach'));
        return;
      }
      else if (!isValidTimeRangeFormat(classTime)) {
        alert(t('memberDetail.courseAddModal.alertEnterClassTime'));
        return;
      }
    }
    else {
      if (scheduleValue.scheduleId === 0) {
        alert(t('memberDetail.courseAddModal.alertSelectClass'));
        return;
      }
    }

    let requestData = {
      classDate: moment(classDate, 'YYYY.MM.DD').format('YYYY-MM-DDT00:00:00'),
      classTime: isClickedNoneLesson ? classTime : scheduleValue.classTime,
      lessonId: isClickedNoneLesson ? 0 : scheduleValue.lessonId,
      deduction: deduction === '' ? 1 : parseInt(deduction),
      userId: membershipValue.userId,
      scheduleId: isClickedNoneLesson ? 0 : scheduleValue.scheduleId,
      usageId: membershipValue.usageId,
      teacherId: isClickedNoneLesson ? teacherValue.teacherId : 0,
      teacherName: isClickedNoneLesson ? teacherValue.teacherName : 0,
      lessonNote: lessonNote
    }
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/course/create', 'POST', requestData);

        if (responseData.status === 200) {
          rendering();
          onClickClose();
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.courseAddModal.alertAlreadyAttended'));
          
        }
        else if (responseData.status === 203) {
          alert(t('memberDetail.courseAddModal.alertClassClosed'));
        }
        else {
          alert(t('memberDetail.courseAddModal.alertCourseAddFailed'));
        }
      }
    )();
  }

  return (
    <TotalModalWrapper>
      <Modal>
        <TotalWrapper>
          <TopTitleWrapper>
            <TitleTextWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{decideMemberName()}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.courseAddModal.courseAddDesc')}</Text>
            </TitleTextWrapper>
            <ButtonWrapper>
              <ExitButton onClick={onClickClose}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
              </ExitButton>
              <SaveButton onClick={onClickSave}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberDetail.courseAddModal.btnAdd')}</Text>
              </SaveButton>
            </ButtonWrapper>
          </TopTitleWrapper>
          <AliveMembershipSelectBoxWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.registeredMembership')}</Text>
            <AliveMembershipSelectBox
              value={membershipValue}
              setValue={setMembershipValue}
              options={membershipOption} />
          </AliveMembershipSelectBoxWrapper>
          {
            isClickedNoneLesson ?
              <TwiceLineWrapper>
                <TwiceInnerWrapper style={{ width: '232.5px' }}>
                  <LessonSelectBoxWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.courseDate')}</Text>
                    <CourseHistoryCalenderInput className='ClassCalender' value={classDate} setValue={setClassDate} clickFn={CalenderClick} placeholder='수강일' width={110} isClickedNoneLesson={isClickedNoneLesson}/>
                  </LessonSelectBoxWrapper>
                  <LessonSelectBoxWrapper>
                    <CourseHistoryTimeInput value={classTime} setValue={setClassTime} width={110}/>
                  </LessonSelectBoxWrapper>
                </TwiceInnerWrapper>
                <TwiceInnerWrapper style={{ width: '232.5px' }}>
                  <LessonSelectBoxHalfWrapper>
                    <LessonSelectBoxTitleWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.coach')}</Text>
                      <CheckBoxWrapper onClick={() => setIsClickedNoneLesson(!isClickedNoneLesson)}>
                        <CheckBox isClicked={isClickedNoneLesson} />
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.courseAddModal.noScheduledClass')}</Text>
                      </CheckBoxWrapper>
                    </LessonSelectBoxTitleWrapper>
                    <NoneSelectLessonWrapper>
                      <LessonSelectBoxWrapper style={{ width: '110px' }}>
                        <CourseHistoryTeacherSelectBox
                          value={teacherValue} 
                          setValue={setTeacherValue} 
                          options={teachers} />
                      </LessonSelectBoxWrapper>
                      <LessonSelectBoxWrapper style={{ width: '110px' }}>
                        <DeductionCountInput value={deduction} setValue={setDeduction} disabled={false} width={110}/>
                      </LessonSelectBoxWrapper>
                    </NoneSelectLessonWrapper>
                  </LessonSelectBoxHalfWrapper>
                </TwiceInnerWrapper>
              </TwiceLineWrapper>
              :
              <TwiceLineWrapper>
                <LessonSelectBoxWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.courseDate')}</Text>
                  <CourseHistoryCalenderInput className='ClassCalender' value={classDate} setValue={setClassDate} clickFn={CalenderClick} placeholder='수강일' width={230} />
                </LessonSelectBoxWrapper>
                <LessonSelectBoxWrapper>
                  <LessonSelectBoxTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.courseClass')}</Text>
                    <CheckBoxWrapper onClick={() => setIsClickedNoneLesson(!isClickedNoneLesson)}>
                      <CheckBox isClicked={isClickedNoneLesson} />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.courseAddModal.noScheduledClass')}</Text>
                    </CheckBoxWrapper>
                  </LessonSelectBoxTitleWrapper>
                  <AliveScheduleSelectBox value={scheduleValue} setValue={setScheduleValue} options={scheduleOption} />
                </LessonSelectBoxWrapper>
              </TwiceLineWrapper>
          }
          <TextAreaWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.courseAddModal.lessonNote')}</Text>
            <LessonNoteTextArea value={lessonNote} setValue={setLessonNote} />
          </TextAreaWrapper>
        </TotalWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;
  
  width: 515px;
  // height: 311px;
  
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0px 20px;

  width: calc(100% - 40px);
`;

const TopTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const AliveMembershipSelectBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  width: 100%;
  
  gap: 8px;

  z-index: 5;
`;

const TwiceLineWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  z-index: 4;
`;

const TwiceInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-end;

  width: 49%;
`;

const LessonSelectBoxHalfWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 8px;
`;

const NoneSelectLessonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const LessonSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 47.5%;

  gap: 8px;
`;

const LessonSelectBoxTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckBox = styled.div`
  width: 15px;
  height: 15px;

  border-radius: 5px;
  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};
  
  margin: 0 0 0 0;
  
  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
  
  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100px;
  height: 40px;
  
  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  gap: 8px;
`;